import PropTypes from 'prop-types';
import { LiftContent, LiftRoot, Shadow } from './Lift.styles';

const spring = {
    standard: { type: 'spring', stiffness: 320, damping: 28 },
};

const lift = {
    rest: { y: 0, rotate: 0, scale: 1 },
    hover: { y: -12, rotate: -2, scale: 1.04 },
    press: { scale: 0.97 },
};

const shadow = {
    rest: { opacity: 0.22 },
    hover: { opacity: 0.55 },
};

export function Lift({ children }) {
    return (
        <LiftRoot
            variants={lift}
            initial="rest"
            animate="rest"
            whileHover="hover"
            whileFocus="hover"
            whileTap="press"
            transition={spring.standard}
        >
            <Shadow variants={shadow} aria-hidden="true" />
            <LiftContent>{children}</LiftContent>
        </LiftRoot>
    );
}

Lift.propTypes = {
    children: PropTypes.node,
};
